import { SVGProps, Ref, forwardRef } from 'react';

export const GearOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.332 7.998c0-1.333.667-2.666 2.666-2.666 2 0 2.666 1.333 2.666 2.666s-.666 2.666-2.666 2.666-2.666-1.333-2.666-2.666m1.4 0c0-.458.117-.767.259-.937.104-.124.344-.329 1.007-.329s.904.205 1.007.33c.142.169.26.478.26.936s-.118.767-.26.937c-.103.124-.344.329-1.007.329s-.903-.205-1.007-.33c-.142-.169-.259-.477-.259-.936"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.96.5h4.08l.516 2.066c.09.363.462.58.822.482l2.082-.57 2.04 3.543-1.558 1.498a.666.666 0 0 0 0 .962L15.5 9.979l-2.04 3.543-2.082-.57a.667.667 0 0 0-.822.482L10.04 15.5H5.96l-.516-2.066a.667.667 0 0 0-.822-.481l-2.081.569L.5 9.979 2.058 8.48a.666.666 0 0 0 0-.962L.5 6.021 2.54 2.48l2.082.569a.666.666 0 0 0 .822-.482zm.843 2.405.25-1.005h1.894l.25 1.005a2.066 2.066 0 0 0 2.55 1.493l1.039-.284.954 1.657-.769.74a2.067 2.067 0 0 0 0 2.979l.77.739-.955 1.657-1.038-.284a2.067 2.067 0 0 0-2.55 1.493L8.947 14.1H7.053l-.25-1.005a2.067 2.067 0 0 0-2.55-1.493l-1.039.284-.954-1.657.769-.74a2.066 2.066 0 0 0 0-2.979l-.77-.739.955-1.657 1.039.284a2.066 2.066 0 0 0 2.55-1.493"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
GearOutlinedSize16Glyph.displayName = 'GearOutlinedSize16Glyph';
